var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoundedBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 122,
    viewBox: "0 0 320 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 122,
    rx: 12,
    fill: "#1F1F22"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M247 0H24C12.6863 0 7.02943 0 3.51472 3.51472C0 7.02944 0 12.6863 0 24V98C0 109.314 0 114.971 3.51472 118.485C7.02943 122 12.6863 122 24 122H247V120.068C247 109.629 243.671 99.461 237.498 91.0424L233.933 86.182C222.31 70.332 223.354 48.5127 236.436 33.8442C243.24 26.2157 247 16.3511 247 6.1294V0Z",
    fill: "#232326"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedBg);
export default __webpack_public_path__ + "static/media/rounded-bg.6a066940b7bbdc47569fef6bef59eb89.svg";
export { ForwardRef as ReactComponent };